import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Portal} from 'react-portal';
import classnames from 'classnames';
import onClickOutside from 'react-onclickoutside';


import styles from './MoreMenu.scss'
import MoreIcon from 'components/assets/icons/MoreIcon';

class MoreMenu extends PureComponent {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.object,]),
        className: PropTypes.string,
    };

    static defaultProps = {
        children: [],
        className: null,
    };

    state = {
        isOpened: false,
    };

    hideMenu = (e) => {
        e.stopPropagation();
        this.setState({isOpened: false});
    };

    switchMenu = (e) => {
        e.stopPropagation();
        this.setState(({isOpened}) => ({isOpened: !isOpened}))
    };

    handleClickOutside = event => {
        this.hideMenu(event);
    };

    getMenuPosition() {
        const anchor = this.refs.anchor;
        if (!anchor)
            return {};
        const rect = anchor.getBoundingClientRect();
        const pointY = rect.bottom;
        const pointX = rect.left + rect.width / 2;
        return {left: `${pointX}px`, top: `${pointY}px`};
    }

    render() {
        const {isOpened} = this.state;
        const {className} = this.props;

        const menuClassName = classnames(styles.menuWrapper, 'ignore-react-onclickoutside', {
            [styles.open]: isOpened
        });

        const containerClassName = classnames(styles.container, className);

        // pass the classname to all children.
        const children = React.Children.map(this.props.children,
            (child, index) => child && React.cloneElement(
                child, {
                    className: classnames(styles.item, child.props.className),
                })
        );

        return (
            <div className={containerClassName} onClick={this.switchMenu} ref='anchor'>
                <MoreIcon active={isOpened} />
                <div className={menuClassName} onClick={this.switchMenu}>
                    {children}
                </div>
            </div>
        );
    }
}

export default onClickOutside(MoreMenu);



// WEBPACK FOOTER //
// ./src/components/controls/MoreMenu.js